import React, { useEffect, useState } from 'react'
import icon_edit from '../../assets/img/edit.svg'
import icon_save from '../../assets/img/save.svg'
import icon_cancel from '../../assets/img/cancel.svg'
import icon_email from '../../assets/img/email.svg'
import MessageAlert from '../tools/MessageAlert'
import { faculdates } from '../../directories/collectionFacultad'
import { genero } from '../../directories/collectionGenero'
import Select from 'react-select'
import { useForm } from '../../hooks/ useForm'
import Loading from '../tools/Loading'
const ItemData = ({label, text, type, message, funcion, pLoad}) => {
    const [value, handleInputChange] =  useForm({texto: text});
    const {texto} = value;
    const [data, setData] = useState()
    const [lbl, setLbl] = useState()
    const [edit, setEdit] = useState(false)
    const [icon, setIcon] = useState('')
    const [valueSelect, setValueSelect] = useState()
    
    
    useEffect(() => {
        if (type === '0') {
            setIcon(icon_email)
        }else {
            setIcon(icon_edit)
        }
        if (label === 'Facultad: ') {
            setData(faculdates)
            setLbl('Seleccione la Facultad')
        }else if (label === 'Genero: ') {
            setData(genero)
            setLbl('Seleccione su genero')
        }
        return () => {
            setIcon('')
            setLbl()
            setData()
            setEdit(false)
        }
    }, [type, label])

    const handleFuncion = () => {
        if (label === 'Facultad: ' || label === 'Genero: ') {
            funcion(valueSelect.value)
        }else{
            funcion(texto)
        }
    }

    return (
        <div className='cont_item_perfil'>
            {
                edit
                ?
                    <>
                        
                        {
                            message 
                            ? 
                                <div className='group_asig'>
                                    <input value={texto} onChange={handleInputChange} name='texto' className='input_item' />
                                    <MessageAlert alert='warn' msg=' Separe cada asignatura con comas “,” ' />
                                </div>
                            : type === '2'
                            ?   <Select 
                                    options={data} 
                                    className='select_perfil' 
                                    placeholder={lbl} 
                                    onChange={setValueSelect}
                                />
                            : <input value={texto} onChange={handleInputChange} name='texto' className='input_item' />
                            
                        }
                        <div className='btn-controls'>
                            {
                                pLoad
                                ? <Loading />
                                :
                                    <>
                                        <i><img src={icon_save} alt='icon' className='btn_icon' onClick={handleFuncion} /></i>
                                        <i><img src={icon_cancel} alt='icon' className='btn_icon' onClick={() => setEdit(!edit)} /></i>
                                    </>
                            }
                            
                        </div>
                    </>
                :
                    <>
                        <p className='item_p'>{label}</p>
                        <div className='group_item_input'>
                            <p className='item_perfil'>{text}</p>
                            <div className='btn-controls'>
                                {
                                    type === '0'
                                    ?<i><img src={icon} alt='icon' className='btn_icon' /></i>
                                    :<i onClick={() => setEdit(!edit)}><img src={icon} alt='icon' className='btn_icon' /></i>
                                }
                                
                            </div>
                        </div>
                    </>
            }
            
        </div>
    )
}

export default ItemData
